module.exports = __webpack_public_path__ + "assets/f14f8351a68f4dbba8e4d4a31f1d2719.mp3";